import type { IconData } from '@stacksjs/iconify-core'

export const heartF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m9.293 1.55l.707.708l.707-.707a5 5 0 1 1 7.071 7.071l-7.07 7.071a1 1 0 0 1-1.415 0L2.222 8.622a5 5 0 1 1 7.07-7.071z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default heartF
